module.exports = __webpack_public_path__ + "img/util-electricity.b52296cd.svg";